/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsersForDiscoverSkeleton.defs.js'
export { main as default } from './getSuggestedUsersForDiscoverSkeleton.defs.js'
